import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { WorkpaperRoleEnum } from '../types/workpaper';
import queryClient from '../query-client';

export type CertifyWorkpaperRequest = { role: WorkpaperRoleEnum };

async function certifyWorkpaper(id: string, req: CertifyWorkpaperRequest): Promise<void> {
    const { data } = await api.post(`/workpapers/${id}/certification`, req);
    return data;
}

export function useCertifyWorkpaper(): UseMutationResult<void, AxiosError, CertifyWorkpaperRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => certifyWorkpaper(workpaperId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['workpapers', workpaperId, 'certification']);
            queryClient.invalidateQueries(['workpapers', workpaperId]);
        },
    });
}
